import { getLocaleSuffix } from "Utils/translationLoader"

export const getAllTasksValidatedNotif = params => {
  const { nonConformityType, nonConformityName, nonConformityAdmin, currentUser, trad } = params
  let message = ""
  if (nonConformityType === "anomaly") message = trad?.ACTION_PLAN_RELATED_ANOMALY + "."
  if (nonConformityType === "incident") message = trad?.ACTION_PLAN_RELATED_INCIDENT + "."
  const localeSuffix = `_${getLocaleSuffix(currentUser?.LANGUAGE_ID)}`
  const notification = {
    to_principals: [`user:${nonConformityAdmin}`],
    data: {
      event: message,
      elementInBold: nonConformityName,
      byUser: "",
      infos: trad?.HAS_BEEN_COMPLETED_AND_READY_VALIDATION,
      email: {
        url: "https://pocketstudio.pocketresult.com/",
        event: `${message}`,
      },
    },
    ephemeral: false,
    channel_id: "validation_action_plan_completed" + localeSuffix,
  }
  return notification
}
